import { Button, Card, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useGetSKUChildrenQuery } from '../features/products/productSlice';
import { useCreateGroupItemMutation, useDeleteGroupItemMutation, useUpdateGroupItemMutation } from '../features/products/skugroupSlice';
import { FamilyProductsAutocomplete } from './ProductAutocomplete';
import DeleteIcon from '@mui/icons-material/Delete';
import ProductCard from './ProductCard';
import Loading from './Loading';

const ChildSKUEditor = ({childSku, onDelete = null}) => {
    let [state, setState] = useState({quantity: 0});
    const [updateGroup, {isLoadingUpdate, isUpdating }] = useUpdateGroupItemMutation();

    return (
            <Grid item key={childSku.id} textAlign="center">
              <Paper variant="outlined"><Card sx={{width: 320, padding:2}}>
              <Stack justifyContent="space-between">
              <center><ProductCard product={childSku.child} nocard={true} /></center>
              <br />
              <Stack direction="row" justifyContent="space-between">
              <TextField label="Quantity" type="number" defaultValue={childSku.quantity} onChange={(event) => {
                  // post the update request
                  let updatedSku = {...childSku, quantity: event.target.value}
                  updateGroup({skugroup_id: childSku.id, data: updatedSku})
                  setState({...state, name: event.target.value});
              }} />
              <Button variant="outlined" onClick={(event) => {
                if(onDelete) {
                  onDelete(childSku)
                }
              }}><DeleteIcon /></Button>
              </Stack></Stack>
              </Card></Paper>
            </Grid>
        );
}

const ProductGroupEditor = ({product, label = "Group contents"}) => {
    const { data: childskus, error, isLoading} = useGetSKUChildrenQuery(product.id);
    const [deleteGroup, {isLoading: isDeleting}] = useDeleteGroupItemMutation();
    const [addGroup, {isLoading: isAdding}] = useCreateGroupItemMutation();
    const [refresh, setRefresh] = useState(1);

    const [addingSKU, setAddingSKU] = useState(null);

    if (isLoading) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const handleDelete = (childsku) => {
      deleteGroup(childsku.id);
      setRefresh(refresh + 1);
    }


    return (
      <>
      <Paper variant="outlined" sx={{padding: 1}}>
      <Typography variant="subtitle1" key={refresh} sx={{marginBottom: 1}}>{label}</Typography>
      <Stack direction="row" spacing={1}>
        <FamilyProductsAutocomplete family_id={product.product_family} onChange={(value) => {
          setAddingSKU(value);
        }} />
        <Button variant="contained" onClick={() => {
          let newChild = {
            child: addingSKU.id,
            parent: product.id,
            quantity: 1
          }
          addGroup(newChild);
        }}>Add</Button>
      </Stack>
      <Grid container spacing={2} sx={{marginTop: 2}}>
      {childskus.objects.map((childSku) => 
        <ChildSKUEditor key={childSku.id} childSku={childSku} onDelete={handleDelete} />
      )}
      </Grid>
      </Paper>
      </>
    );
}

export default ProductGroupEditor;
